import { UserRole } from 'types/UserRole'

const ADMIN_ROLE: UserRole = 'ADMINS'
const COMPANY_ROLE: UserRole = 'COMPANIES'
const CONTENT_CREATOR_ROLE: UserRole = 'CONTENT_CREATORS'
const TEACHER_ROLE: UserRole = 'TEACHERS'
const PARTICIPANT_ROLE: UserRole = 'PARTICIPANTS'

export { ADMIN_ROLE, COMPANY_ROLE, CONTENT_CREATOR_ROLE, TEACHER_ROLE, PARTICIPANT_ROLE }
